import { render, staticRenderFns } from "./FreightExchangeControl.vue?vue&type=template&id=1c6f0728&scoped=true"
import script from "./FreightExchangeControl.vue?vue&type=script&lang=js"
export * from "./FreightExchangeControl.vue?vue&type=script&lang=js"
import style0 from "./FreightExchangeControl.vue?vue&type=style&index=0&id=1c6f0728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f0728",
  null
  
)

export default component.exports